// extracted by mini-css-extract-plugin
export var exhibitCopy = "fixedContent-module--exhibitCopy--9d332";
export var exhibitDetails = "fixedContent-module--exhibitDetails--9e9f2";
export var exhibitInfo = "fixedContent-module--exhibitInfo--f8a26";
export var fixedSection = "fixedContent-module--fixedSection--adf7b";
export var heading = "fixedContent-module--heading--a6a79";
export var linksContainer = "fixedContent-module--linksContainer--9f602";
export var tagContainer = "fixedContent-module--tagContainer--228fd";